<template>
  <div>
    <b-row class="mt-5">
      <b-col>
        <div class="row">
          <div class="col-md-6 my-auto">
            <h4 class="m-0">Welcome</h4>
          </div>
        </div>
      </b-col>
    </b-row>

    <div class="row mt-3">
      <div class="col-lg-4">
        <div class="card r22">
          <div class="card-body">
            <h6 class="font-weight-bold">Payment Reminder Processor Log</h6>
            <hr />
            <b-list-group>
              <b-list-group-item
                v-for="rp in reminder_payment_processor_logs"
                :key="rp.id"
                class="
                  d-flex
                  justify-content-between
                  align-items-center
                  p-1
                  border-0 border-bottom
                "
              >
                {{ rp.last_checked }}
                <b-badge variant="primary" pill>{{
                  rp.orders_processed
                }}</b-badge>
              </b-list-group-item>
            </b-list-group>
          </div>
        </div>
        <div class="card mt-2 r22">
          <div class="card-body">
            <h6 class="font-weight-bold">Cancel Order Processor Log</h6>
            <hr />
            <b-list-group>
              <b-list-group-item
                v-for="rp in orders_cancelled_processor_logs"
                :key="rp.id"
                class="
                  d-flex
                  justify-content-between
                  align-items-center
                  p-1
                  border-0 border-bottom
                "
              >
                {{ rp.last_checked }}
                <b-badge variant="primary" pill>{{
                  rp.orders_processed
                }}</b-badge>
              </b-list-group-item>
            </b-list-group>
          </div>
        </div>
      </div>
      <div class="col-lg-8">
        <div class="row">
          <div class="col-12">
            <h5 class="font-weight-bold">FNB Payments Recieved</h5>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-4">
            <div class="card r22">
              <div class="card-body">
                <h6 class="font-weight-bold">Today</h6>
                <hr />
                <h1 class="text-primary">{{ paid_today }}</h1>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card r22">
              <div class="card-body">
                <h6 class="font-weight-bold">Yesterday</h6>
                <hr />
                <h1 class="text-primary">{{ paid_yesterday }}</h1>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card r22">
              <div class="card-body">
                <h6 class="font-weight-bold">Month</h6>
                <hr />
                <h1 class="text-primary">{{ paid_month }}</h1>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12">
            <h5 class="font-weight-bold">Payment Reminder Sent</h5>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-4">
            <div class="card r22">
              <div class="card-body">
                <h6 class="font-weight-bold">Today</h6>
                <hr />
                <h1 class="text-primary">
                  {{ reminder_payment_today_success }}
                </h1>
                <h1
                  class="text-danger"
                  v-if="reminder_payment_today_failed != 0"
                >
                  {{ reminder_payment_today_failed }}
                </h1>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card r22">
              <div class="card-body">
                <h6 class="font-weight-bold">Yesterday</h6>
                <hr />
                <h1 class="text-primary">
                  {{ reminder_payment_yesterday_success }}
                </h1>
                <h1
                  class="text-danger"
                  v-if="reminder_payment_yesterday_failed != 0"
                >
                  {{ reminder_payment_yeserday_failed }}
                </h1>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card r22">
              <div class="card-body">
                <h6 class="font-weight-bold">Month</h6>
                <hr />
                <h1 class="text-primary">
                  {{ reminder_payment_month_success }}
                </h1>
                <h1
                  class="text-danger"
                  v-if="reminder_payment_month_failed != 0"
                >
                  {{ reminder_payment_month_failed }}
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12">
            <h5 class="font-weight-bold">Order Cancellations Sent</h5>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-4">
            <div class="card r22">
              <div class="card-body">
                <h6 class="font-weight-bold">Today</h6>
                <hr />
                <h1 class="text-primary">
                  {{ order_cancelled_today_success }}
                </h1>
                <h1
                  class="text-danger"
                  v-if="order_cancelled_today_failed != 0"
                >
                  {{ order_cancelled_today_failed }}
                </h1>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card r22">
              <div class="card-body">
                <h6 class="font-weight-bold">Yesterday</h6>
                <hr />
                <h1 class="text-primary">
                  {{ order_cancelled_yesterday_success }}
                </h1>
                <h1
                  class="text-danger"
                  v-if="order_cancelled_yesterday_failed != 0"
                >
                  {{ order_cancelled_yesterday_failed }}
                </h1>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card r22">
              <div class="card-body">
                <h6 class="font-weight-bold">Month</h6>
                <hr />
                <h1 class="text-primary">
                  {{ order_cancelled_month_success }}
                </h1>
                <h1
                  class="text-danger"
                  v-if="order_cancelled_month_failed != 0"
                >
                  {{ order_cancelled_month_failed }}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dashboardRepo from "../../api/repos/dashboardRepo";

export default {
  mounted() {
    this.getDashboard();
  },

  methods: {
    async getDashboard() {
      try {
        let { data } = await dashboardRepo.dashboard();
        this.paid_today = data.paid_today;
        this.paid_yesterday = data.paid_yesterday;
        this.paid_month = data.paid_month;
        this.reminder_payment_today_success = data.reminder_payment_today_success;
        this.reminder_payment_yesterday_success = data.reminder_payment_yesterday_success;
        this.reminder_payment_month_success = data.reminder_payment_month_success;
        this.order_cancelled_today_success = data.order_cancelled_today_success;
        this.order_cancelled_yesterday_success = data.order_cancelled_yesterday_success;
        this.order_cancelled_month_success = data.order_cancelled_month_success;
        this.reminder_payment_today_failed = data.reminder_payment_today_failed;
        this.reminder_payment_yesterday_failed = data.reminder_payment_yesterday_failed;
        this.reminder_payment_month_failed = data.reminder_payment_month_failed;
        this.order_cancelled_today_failed = data.order_cancelled_today_failed;
        this.order_cancelled_yesterday_failed = data.order_cancelled_yesterday_failed;
        this.order_cancelled_month_failed = data.order_cancelled_month_failed;
        this.reminder_payment_processor_logs =
          data.reminder_payment_processor_logs;
        this.orders_cancelled_processor_logs =
          data.orders_cancelled_processor_logs;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },

  data() {
    return {
      paid_today: 0,
      paid_yesterday: 0,
      paid_month: 0,
      reminder_payment_today_success: 0,
      reminder_payment_yesterday_success: 0,
      reminder_payment_month_success: 0,
      order_cancelled_today_success: 0,
      order_cancelled_yesterday_success: 0,
      order_cancelled_month_success: 0,
      reminder_payment_today_failed: 0,
      reminder_payment_yesterday_failed: 0,
      reminder_payment_month_failed: 0,
      order_cancelled_today_failed: 0,
      order_cancelled_yesterday_failed: 0,
      order_cancelled_month_failed: 0,
      reminder_payment_processor_logs: [],
      orders_cancelled_processor_logs: [],
    };
  },
};
</script>

<style>
.r22 {
  border-radius: 22px;
}
</style>